import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppTopbar } from '../app.topbar';
import { AppSidebar } from './sidebar/sidebar.component';

@Component({
  selector: 'app-layout',
  imports: [AppTopbar, RouterOutlet],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent {

}
